import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export default function SettingInfo({ description, viewLink }) {
  const tooltipContent = (
    <div className="flex flex-col gap-2 max-w-xs">
      {/* Description text */}
      <p className="text-sm text-gray-700">{description}</p>

      {/* Preview image */}
      <img
        src={viewLink}
        alt="Preview"
        className="w-40 h-auto  border-gray-200 shadow-lg"
      />
    </div>
  );

  return (
    <Tooltip title={tooltipContent} placement="right" color="white">
      <InfoCircleOutlined className="text-gray-500 hover:text-blue-500 cursor-pointer ml-2" />
    </Tooltip>
  );
}
